import { cloneElement } from 'react';
import { Form } from 'antd';

import Input from '@/v2/components/Input';

import BaseModal from './BaseModal';
import { Container } from './DeleteModal.styled';

export default function DeleteModal({
  onDelete,
  SaveButton,
  children,
  ...props
}) {
  const [form] = Form.useForm();

  const SaveButtonWithForm = cloneElement(SaveButton, {
    htmlType: 'submit',
    onClick: form.submit,
  });

  return (
    <BaseModal SaveButton={SaveButtonWithForm} {...props} closable={false}>
      <Container>
        {children}
        <Form form={form} onFinish={onDelete}>
          <Form.Item
            name="confirm"
            rules={[
              {
                validator: (_, value) => {
                  if (!value || value === '') {
                    return Promise.reject(
                      new Error('Please type DELETE to confirm')
                    );
                  }
                  return Promise.resolve();
                },
              },
              {
                validator: (_, value) => {
                  if (
                    value !== 'DELETE' &&
                    typeof value !== 'undefined' &&
                    value !== ''
                  ) {
                    return Promise.reject(
                      new Error('You must type exactly "DELETE"')
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input placeholder="Type DELETE here" autoComplete="off" />
          </Form.Item>
        </Form>
      </Container>
    </BaseModal>
  );
}
